function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M20 7.911h-7.534l3.045-3.133c-3.033-3-7.944-3.111-10.978-.111a7.639 7.639 0 000 10.877c3.034 3.012 7.945 3.012 10.978 0 1.511-1.488 2.267-3.233 2.267-5.433H20c0 2.2-.978 5.056-2.933 6.989-3.9 3.867-10.234 3.867-14.134 0C-.956 13.244-.989 6.978 2.911 3.122a9.986 9.986 0 0114.055 0L20 0v7.911zm-9.445-2.355v4.722l3.89 2.31-.8 1.345-4.756-2.822V5.556h1.666z"
})));